import "core-js/modules/es.array.push.js";
export default {
  name: "mSlide",
  props: {
    step: {
      type: Array,
      default: () => [1, 2, 4, 6, 8, 10, 20]
    },
    defaultValue: {
      default: 0
    }
  },
  data() {
    return {
      isDragging: false,
      currentValue: this.step[this.defaultValue],
      thumbPosition: 0,
      filledWidth: 0,
      marks: [],
      thumbOffset: 0
    };
  },
  computed: {
    sliderWidth() {
      return this.$refs.slider ? this.$refs.slider.clientWidth : 0;
    },
    segmentWidth() {
      return this.step.length > 1 ? this.sliderWidth / (this.step.length - 1) : 0;
    }
  },
  methods: {
    generateColors(count) {
      const colors = [];
      for (let i = 0; i < count; i++) {
        let r = 254; // 红色保持不变
        let g = Math.round(57 + (146 - 57) * (i / (count - 1))); // 57 → 146
        let b = Math.round(92 - (92 - 63) * (i / (count - 1))); // 92 → 63
        colors.push(`#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`);
      }
      return colors;
    },
    startDrag(event) {
      this.isDragging = true;
      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
      document.addEventListener("touchmove", this.onDrag);
      document.addEventListener("touchend", this.stopDrag);
      this.onDrag(event);
    },
    onDrag(event) {
      if (!this.isDragging) return;
      const clientX = event.touches ? event.touches[0].clientX : event.clientX;
      const rect = this.$refs.slider.getBoundingClientRect();
      let newPosition = clientX - rect.left;
      newPosition = Math.max(0, Math.min(newPosition, this.sliderWidth));
      let closestMark = this.marks.reduce((prev, curr) => Math.abs(curr.position - newPosition) < Math.abs(prev.position - newPosition) ? curr : prev);
      this.currentValue = closestMark;
      this.thumbPosition = closestMark.position;
      this.filledWidth = this.thumbPosition;
      this.$emit("selectFn", this.currentValue);
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
      document.removeEventListener("touchmove", this.onDrag);
      document.removeEventListener("touchend", this.stopDrag);
    },
    calculateMarks() {
      if (!this.sliderWidth || this.step.length === 0) return;
      const colorList = this.generateColors(this.step.length);
      this.marks = this.step.map((item, index) => ({
        multiple: item.multiple,
        position: index * this.segmentWidth,
        color: colorList[index] || "#ffffff",
        stars: item.stars
      }));
      console.log("this.stepthis.stepthis.step", this.step, this.marks);
      this.updateThumbPosition();
    },
    updateThumbPosition() {
      let initialMark = this.marks.find(mark => mark.multiple === this.currentValue.multiple) || this.marks[0];
      this.thumbPosition = initialMark.position;
      this.filledWidth = this.thumbPosition;
    }
  },
  mounted() {
    this.$nextTick(this.calculateMarks);
    window.addEventListener("resize", this.calculateMarks);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateMarks);
    this.stopDrag();
  }
};